import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {SET_PAGE, SET_PAGE_SIZE} from "../../../Redux/Actions";

export const PaginationComponent = props => {
    const dispatch = useDispatch();

    const {page, pageSize,} = useSelector(state => state.queryToolState);

    return <div className="pagination-bottom">
        <div className="-previous">
            <button
                type="button"
                className="-btn"
                onClick={() => dispatch({type: SET_PAGE, page: page - 1})}
                disabled={!props.getCanPreviousPage()}
            >
                Previous
            </button>
        </div>
        <div className="-center">
            <span className="-pageInfo">
                Page
                <div className="pageJump">
                    <input
                        type="number"
                        value={page + 1}
                        onChange={(e) => dispatch({type: SET_PAGE, page: e.target.value})}
                    />
                </div>
                of
                <span className="-totalPages">{props.getPageCount()}</span>
            </span>
            <span className="select-wrap -pageSizeOptions">
                <select
                    value={pageSize}
                    onChange={(e) => dispatch({type: SET_PAGE_SIZE, pageSize: e.target.value})}>
                    {
                        [5, 10, 20, 25, 50, 100].map(rowCount => (
                            <option key={rowCount} value={rowCount}>{rowCount} rows</option>
                        ))
                    }
                </select>
            </span>
        </div>
        <div className="-next">
            <button
                type="button"
                className="-btn"
                onClick={() => dispatch({type: SET_PAGE, page: page + 1})}
                disabled={!props.getCanNextPage()}
            >
                Next
            </button>
        </div>
    </div>;
};
